import React, { useEffect, useState } from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import icon_img from "../../images/logo.png";
import { registerUser } from "../../service/logic";
import { showModal } from "../../redux/dispatchers";
import { history } from "../../index";
import { getOptions } from "../../service/api/option";
import { fontSize } from "../../styles";
import { OpeningLayout } from "../common";

const useStyles = makeStyles((theme) => ({
  logo: {
    width: 330,
    [theme.breakpoints.down("sm")]: {
      width: 250,
    },
    [theme.breakpoints.down("xs")]: {
      width: "55%",
    },
  },
  paper: {
    height: "100vh",
    width: "50%",
    [theme.breakpoints.down("sm")]: {
      width: "60%",
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      padding: "50px 10px",
    },
    padding: 50,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    zIndex: 1,
  },
  form: {
    width: "90%",
    color: "#1D3557",
  },
  inputfield: {
    color: "#1D3557",
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: `0px solid white`,
      },
      "&.Mui-focused fieldset": {
        border: `0px solid white`,
      },
    },
  },
  input: {
    color: "#1D3557",
    "&:hover": {
      color: "#457B9D",
    },
  },
  placeholderColor: {
    "&::placeholder": {
      color: "black",
      fontWeight: "bold",
    },
  },
  buttonContainer: {
    textAlign: "center",
  },
  submit: {
    paddingLeft: 75,
    paddingRight: 75,
    backgroundColor: "#1D3557",
    borderRadius: 16,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    fontSize: fontSize.h4,
    "&:hover": {
      backgroundColor: "#457B9D",
    },
    [theme.breakpoints.down("xs")]: {
      paddingLeft: 55,
      paddingRight: 55,
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
  },
  linktext: {
    marginLeft: 10,
    color: "red",
    textDecoration: "underline",
  },
  errorStyle: {
    color: "red",
    marginBottom: 10,
  },
  imageHolder: {
    [theme.breakpoints.down("xs")]: {
      justifyContent: "flex-start",
    },
    display: "flex",
    width: "100%",
    justifyContent: "center",
  },
}));

export default function RegisterScreen() {
  const classes = useStyles();

  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [nickname, setNickname] = useState("");
  const [matricNo, setMatricNo] = useState("");
  const [oldMatricNo, setOldMatricNo] = useState("");
  const [cohort, setCohort] = useState(2020);
  const [errorMessage, setErrorMessage] = useState("");
  const [stages, setStages] = useState([]);
  const [stage, setStage] = useState("stage_Stage1");

  // on load, get stages
  useEffect(() => {
    // get stage options
    getOptions("stage").then((d) => {
      setStages(d);
    });
  }, []);

  const handleSelect = (event) => {
    setStage(event.target.value);
  };

  const checkPassword = () => {
    if (password === confirmPassword) {
      return true;
    }

    setErrorMessage("Password not match!");
    return false;
  };

  const onRegister = async (event) => {
    event.preventDefault();

    // if password matched then call register
    if (checkPassword()) {
      const e = await registerUser({
        data: {
          name: username,
          password: password,
          nickname: nickname,
          matricNumber: matricNo,
          oldMatricNumber: oldMatricNo,
          email: email,
          stage: stage,
          cohort,
          verified: true,
        },
      });
      if (!!e) {
        setErrorMessage(e);
        return;
      }

      showModal(
        "Registration Success",
        "You have successfully created an account.",
        null,
        "Close"
      );
      history.push("/login");
    }
  };

  return (
    <React.Fragment>
      <CssBaseline />
      <OpeningLayout
        content={
          <div className={classes.paper}>
            <div className={classes.imageHolder}>
              <img
                className={classes.logo}
                src={icon_img}
                alt={"Virtual Patient"}
              />
            </div>
            <form className={classes.form} noValidate>
              <TextField
                className={classes.inputfield}
                margin="normal"
                fullWidth
                id="username"
                placeholder="Name"
                name="username"
                value={username}
                onChange={(event) => {
                  setUsername(event.target.value);
                }}
                InputProps={{
                  className: classes.input,
                  classes: { input: classes.placeholderColor },
                }}
              />
              <TextField
                className={classes.inputfield}
                margin="normal"
                fullWidth
                id="nickname"
                placeholder="Nickname"
                name="nickname"
                value={nickname}
                onChange={(event) => {
                  setNickname(event.target.value);
                }}
                InputProps={{
                  className: classes.input,
                  classes: { input: classes.placeholderColor },
                }}
              />
              <TextField
                className={classes.inputfield}
                margin="normal"
                fullWidth
                id="email"
                placeholder="Email"
                name="email"
                onChange={(event) => {
                  setEmail(event.target.value);
                }}
                value={email}
                InputProps={{
                  className: classes.input,
                  classes: { input: classes.placeholderColor },
                }}
              />
              <TextField
                className={classes.inputfield}
                margin="normal"
                fullWidth
                name="password"
                placeholder="Password"
                type="password"
                value={password}
                id="password"
                autoComplete="current-password"
                onChange={(event) => {
                  setPassword(event.target.value);
                }}
                InputProps={{
                  className: classes.input,
                  classes: { input: classes.placeholderColor },
                }}
              />
              <TextField
                className={classes.inputfield}
                margin="normal"
                fullWidth
                name="currentPassword"
                placeholder="Confirm Password"
                type="password"
                id="confirm_password"
                value={confirmPassword}
                autoComplete="currentPassword"
                onChange={(event) => {
                  setConfirmPassword(event.target.value);
                }}
                InputProps={{
                  className: classes.input,
                  classes: { input: classes.placeholderColor },
                }}
              />
              <TextField
                className={classes.inputfield}
                margin="normal"
                fullWidth
                id="matricNo"
                value={matricNo}
                placeholder="Matric Number"
                name="matricNo"
                onChange={(event) => {
                  setMatricNo(event.target.value);
                }}
                InputProps={{
                  className: classes.input,
                  classes: { input: classes.placeholderColor },
                }}
              />
              <TextField
                className={classes.inputfield}
                margin="normal"
                fullWidth
                id="oldMatricNo"
                placeholder="Old Matric Number"
                name="oldMatricNo"
                value={oldMatricNo}
                onChange={(event) => {
                  setOldMatricNo(event.target.value);
                }}
                InputProps={{
                  className: classes.input,
                  classes: { input: classes.placeholderColor },
                }}
              />
              <TextField
                className={classes.inputfield}
                margin="normal"
                fullWidth
                id="cohort"
                value={cohort}
                placeholder="Cohort"
                name="cohort"
                onChange={(event) => {
                  setCohort(event.target.value);
                }}
                type="number"
                InputProps={{
                  className: classes.input,
                  classes: { input: classes.placeholderColor },
                }}
              />
              <TextField
                className={`${classes.inputfield} ${classes.select}`}
                margin="normal"
                fullWidth
                select
                id="stage"
                value={stage}
                placeholder="Stage"
                name="stage"
                onChange={handleSelect}
                SelectProps={{
                  native: true,
                }}
                inputProps={{ className: classes.input }}
              >
                {stages.map((stage) => (
                  <option key={stage.id} value={stage.id}>
                    {stage.name}
                  </option>
                ))}
              </TextField>
              <Typography className={classes.errorStyle}>
                {errorMessage}
              </Typography>
              <div className={classes.buttonContainer}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                  onClick={onRegister}
                >
                  Register
                </Button>
              </div>
              <Grid
                container
                direction="row"
                justify="center"
                alignItems="center"
              >
                <p>Already have account ?</p>
                <Link href="/login">
                  <Typography className={classes.linktext}>
                    {"Login"}
                  </Typography>
                </Link>
              </Grid>
            </form>
          </div>
        }
      />
    </React.Fragment>
  );
}
